import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export const defaultAction = ({ service, title, value }) => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id } = params;

        const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);

        const handleOpenConfirmationModal = event => {
            event.stopPropagation();
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };

        const [loading, setLoading] = useState(false);

        const handleConfirm = async event => {
            event.stopPropagation();
            try {
                setLoading(true);
                await service(id);
                enqueueSnackbar('Action completed successfully', {
                    variant: 'success',
                });
            } catch (err) {
                enqueueSnackbar(err.message, { variant: 'error' });
            } finally {
                setLoading(false);
                onClick();
                handleCloseConfirmationModal();
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={handleCloseConfirmationModal}
                                variant="outlined"
                                color="secondary"
                            >
                                Close
                            </Button>
                        </>
                    )}
                >
                    <Stack spacing={2} direction="column">
                        <LoadingButton
                            variant="contained"
                            size={'small'}
                            onClick={event => handleConfirm(event)}
                            loading={loading}
                        >
                            <span>Confirm</span>
                        </LoadingButton>
                    </Stack>
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={title}
                    onClick={event => handleOpenConfirmationModal(event)}
                    {...restProps}
                >
                    {title}
                </MenuItem>
            </>
        );
    };
};
